<template>
<div>
  <v-layout style="padding-top: 150px">
    <v-flex xs12 sm12 md12 lg12>
      <div>
        <v-card class="mx-auto" max-width="500" outlined
        >
          <v-img :src="require('../assets/splash.jpg')" />
          <v-overlay
            opacity="0.6"
            absolute
            color="black"
            style="padding: 10px;"
          >
          <v-card-title class="justify-center"><h3>{{title}}</h3></v-card-title>
          <v-divider />
          <p>{{msg}}</p>
          <ValidationObserver ref="observer" >
            <div v-if="showform">
            <ValidationProvider
              name="email"
              ref="email"
              rules="required"
              v-slot="{ errors }"
              :bails="false"
            >
              <v-text-field
                prepend-icon="email"
                v-model="email"
                label="Email"
                outlined
                autofocus
                v-on:keyup.enter="submit"
              ></v-text-field>
              <ul style="color: red" class="overline text-left">
                <li v-for="(error, index) in errors" :key="index">
                  <span>{{ error }}</span>
                </li>
              </ul>
            </ValidationProvider>
            <v-text-field
                prepend-icon="person"
                v-model="name"
                label="Name"
                outlined
                autofocus
                v-on:keyup.enter="submit"
              ></v-text-field>
            <v-text-field
                prepend-icon="domain"
                v-model="company"
                label="Company Name"
                outlined
                autofocus
                v-on:keyup.enter="submit"
              ></v-text-field>
            </div>
            <v-card-actions>
              <v-spacer></v-spacer>
              <!-- <v-btn :disabled="!valid" @click="signIn()" text>Login</v-btn> -->
              <v-btn v-if="showform" :disabled="!valid" @click="submit()" text>Submit</v-btn>
              <v-btn @click="cancel" text>{{showform ? 'cancel' : 'ok' }}</v-btn>
            </v-card-actions>
          </ValidationObserver>
          </v-overlay>
        </v-card>
      </div>
    </v-flex>
  </v-layout>
  </div>
</template>

<script>
import {ValidationProvider, extend} from "vee-validate/dist/vee-validate.full"
import { ValidationObserver } from "vee-validate/dist/vee-validate.full"
import { sync } from "vuex-pathify"
import axiosInstances from '../server/axiosInstances'
extend("required", {
  message: (field, values) => "You must enter a " + `${field}`,
});
// create custom error message for custom rule
export default {
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  data: () => ({
    showform: true,
    name: null,
    company: null,
    show1: false,
    email: "",
    title: "Sign Up for Free Cortex Silver Account",
    msg: ""
  }),
  computed: {
    loginDialog: sync('login/loginDialog'),
    loggedIn: sync('login/loggedIn'),
    loggedinUser: sync('login/loggedinUser'),
    loginFailed: sync('login/loginFailed'),
    // loginActions: sync('login/loginActions'),
    valid() {
      return (this.email != '' && this.email != null)
    },
  },
  methods: {
    submit () {
      this.showform = false
      this.title = "Account Request Received"
      this.msg =
        "You will receive a validation email shortly. If you do not see an email from Entrinsia in a few hours, please check your spam folders or contact support@entrinsia.com"
    },
    clear() {
      this.email = null
      this.title = "Sign Up for Free Cortex Silver Account"
      this.name = null
      this.company = null
    },
    cancel() {
      this.clear();
      this.loggedinUser = true
      this.$router.push('/')
    }
  },
  watch: {
    
  },
  mounted() {
    this.clear()
    this.showform = true
    this.title = "Sign Up for Free Cortex Silver Account"
  },
};
</script>
